import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { AiNativeEngineering } from './pages/AiNativeEngineering';
function ScrollManager() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
        return;
      }
    }
    window.scrollTo({
      top: 0
    });
  }, [pathname, hash]);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2wiywaq163pam">
      <div className="min-h-screen bg-navy text-white font-sans selection:bg-teal selection:text-navy" data-id="element-1" data-mp="2wifh3h2wjf0a">
        <ScrollManager data-id="element-2" data-mp="28sl3uyeo7ofi" />
        <Navbar data-id="element-3" data-mp="28s30zixi6bym" />
        <main data-id="element-4" data-mp="23vktwcepa1j4">
          <Routes data-id="element-5" data-mp="23w4e5zrtp20b">
            <Route path="/" element={<Home data-id="element-7" data-mp="23t8heerpojdg" />} data-id="element-6" data-mp="23ujlygszdv5m" />
            <Route path="/services/ai-native-engineering" element={<AiNativeEngineering data-id="element-9" data-mp="3ihuyk4ft23e4" />} data-id="element-8" data-mp="3ijxo6nd1puib" />
            <Route path="*" element={<Navigate to="/" replace data-id="element-11" data-mp="3mjzu58ptda3e" />} data-id="element-10" data-mp="3mkhlps1j704z" />
          </Routes>
        </main>
        <Footer data-id="element-12" data-mp="3rdaquh0wwahl" />
      </div>
    </BrowserRouter>;
}